import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AccountingIcon from '../icons/AccountingIcon';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import TickMark from '../icons/TickMark';
import ManagementIcon from '../icons/ManagementIcon';
import SpeakerIcon from '../icons/SpeakerIcon';
import TechIcon from '../icons/TechIcon';
import BankAccountIcon from '../icons/BankAccountIcon';
import BookingIcon from '../icons/BookingIcon';
import SetupIcon from '../icons/SetupIcon';
import SpeedometerIcon from '../icons/SpeedometerIcon';
import DollarViewIcon from '../icons/DollarViewIcon';
import DollarInHandIcon from '../icons/DollarInHandIcon';
import { generateUniqueId } from '../utils';
import SaveIcon from '../icons/SaveIcon';
import FormationIcon from '../icons/FormationIcon';
import { useAuth } from '../hooks/useAuth';

// common
export const TASK_STATUS_CONSTANTS = {
    TASK_ADDED: 'TASK_ADDED',
    TASK_NOT_STARTED: 'TASK_NOT_STARTED',
    TASK_IN_PROGRESS: 'TASK_IN_PROGRESS',
    TASK_COMPLETED: 'TASK_COMPLETED',
};

export const BUSINESS_NAVIGATOR_LIST = [
    {
        id: 1,
        displayHeading: 'LLC Formation',
        icon: <CheckCircleOutlineIcon />,
        para: '3/3 completed',
        isCompleted: true,
        list: [
            {
                id: generateUniqueId(),
                icon: <BankAccountIcon />,
                heading: 'LLC Setup',
                endIcon: <SaveIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <BookingIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <SetupIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <SpeedometerIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <DollarViewIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <DollarInHandIcon />,
            },
        ],
    },
    {
        id: 2,
        displayHeading: 'Banking & Accounting',
        icon: <AccountingIcon />,
        para: '6 Suggested Solutions',
        isCompleted: false,
        list: [
            {
                id: 1,
                icon: <BankAccountIcon />,
                heading: 'Open a bank account',
                endIcon: <SaveIcon />,
            },
            {
                id: 2,
                icon: <BookingIcon />,
                heading: 'Bookkeeping',
                endIcon: <SaveIcon />,
            },
            {
                id: 3,
                icon: <SetupIcon />,
                heading: 'Setup D&B Number',
                endIcon: <SaveIcon />,
            },
            {
                id: 4,
                icon: <SpeedometerIcon />,
                heading: 'Open a line of credit',
            },
            {
                id: 5,
                icon: <DollarViewIcon />,
                heading: 'Online Payment Processing',
            },
            {
                id: 6,
                icon: <DollarInHandIcon />,
                heading: 'Setup Payroll',
            },
        ],
    },
    {
        id: 3,
        displayHeading: 'Tax Planning & Preparation',
        icon: <PaidOutlinedIcon />,
        para: '6 Suggested Solutions',
        isCompleted: false,
        list: [
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <BankAccountIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <BookingIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <SetupIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <SpeedometerIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <DollarViewIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <DollarInHandIcon />,
            },
        ],
    },
    {
        id: 4,
        displayHeading: 'Legal & Compliance',
        icon: <TickMark />,
        para: '6 Suggested Solutions',
        isCompleted: false,
        list: [
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <BankAccountIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <BookingIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <SetupIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <SpeedometerIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <DollarViewIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <DollarInHandIcon />,
            },
        ],
    },
    {
        id: 5,
        displayHeading: 'Risk Management & Insurance',
        icon: <ManagementIcon />,
        para: '6 Suggested Solutions',
        isCompleted: false,
        list: [
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <BankAccountIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <BookingIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <SetupIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <SpeedometerIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <DollarViewIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <DollarInHandIcon />,
            },
        ],
    },
    {
        id: 6,
        displayHeading: 'Branding & Marketing',
        icon: <SpeakerIcon />,
        para: '6 Suggested Solutions',
        isCompleted: false,
        list: [
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <BankAccountIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <BookingIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <SetupIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <SpeedometerIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <DollarViewIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <DollarInHandIcon />,
            },
        ],
    },
    {
        id: 7,
        displayHeading: 'IT & Technology',
        icon: <TechIcon />,
        para: '6 Suggested Solutions',
        isCompleted: false,
        list: [
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <BankAccountIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <BookingIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <SetupIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <SpeedometerIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <DollarViewIcon />,
            },
            {
                id: generateUniqueId(),
                heading: 'heading',
                icon: <DollarInHandIcon />,
            },
        ],
    },
];

export const CHECKLIST_NAVIGATOR_LIST = [
    {
        id: 1,
        displayHeading: 'LLC Formation',
        icon: <FormationIcon />,
        para: '3 Task',
        list: [
            {
                id: generateUniqueId(),
                heading: 'Sign Articles of Incorporation',
                status: TASK_STATUS_CONSTANTS.TASK_COMPLETED,
                total: 4,
                completedTasks: 2,
            },
            {
                id: generateUniqueId(),
                heading: 'Submit',
                status: TASK_STATUS_CONSTANTS.TASK_COMPLETED,
                total: 2,
                completedTasks: 2,
            },
            {
                id: generateUniqueId(),
                heading: 'Setup D&B Number',
                status: TASK_STATUS_CONSTANTS.TASK_IN_PROGRESS,
                total: 3,
                completedTasks: 1,
            },
        ],
    },
    {
        id: 2,
        displayHeading: 'Banking & Accounting',
        icon: <AccountingIcon />,
        para: '3 Tasks',
        list: [
            {
                id: 1,
                heading: 'Open a bank account',
                status: TASK_STATUS_CONSTANTS.TASK_COMPLETED,
                total: 3,
                completedTasks: 3,
            },
            {
                id: 2,
                heading: 'Bookkeeping',
                status: TASK_STATUS_CONSTANTS.TASK_IN_PROGRESS,

                total: 4,
                completedTasks: 1,
            },
            {
                id: 3,
                heading: 'Setup D&B Number',
                status: TASK_STATUS_CONSTANTS.TASK_NOT_STARTED,

                total: 3,
                completedTasks: 0,
            },
        ],
    },
    {
        id: 3,
        displayHeading: 'Tax Planning & Preparation',
        icon: <PaidOutlinedIcon />,
        para: '4 Tasks',
        list: [
            {
                id: generateUniqueId(),
                heading: 'Open a bank account',
                status: TASK_STATUS_CONSTANTS.TASK_NOT_STARTED,
                total: 3,
                completedTasks: 0,
            },
            {
                id: generateUniqueId(),
                heading: 'Bookkeeping',
                status: TASK_STATUS_CONSTANTS.TASK_NOT_STARTED,
                total: 3,
                completedTasks: 0,
            },
            {
                id: generateUniqueId(),
                heading: 'Setup D&B Number',
                status: TASK_STATUS_CONSTANTS.TASK_NOT_STARTED,
                total: 3,
                completedTasks: 0,
            },
        ],
    },
];

export const COMPANY_LIST_DETAILS = (hideHousehold) => {
    const { getUserDetailsNotAsync, setUserDetailsNotAsync, refreshSessionData } = useAuth();
    const userDetails = getUserDetailsNotAsync();
    return userDetails?.contact?.relatedAccounts
        .sort((a, b) => a.accountName.localeCompare(b.name))
        .filter((item) => !hideHousehold || item.accountId !== userDetails?.contact.accountId)
        .map((item) => {
            return {
                id: item.accountId,
                checked: false,
                name: item.accountId !== userDetails?.contact.accountId ? item.accountName : userDetails?.contact.name,
                status: '',
            };
        });
};

export const SUPPORT_TYPE_LIST = {
    'Entity Formation': [
        { label: 'Amendment', value: 'Biz Help' },
        { label: 'Dissolution', value: 'Biz Help' },
        { label: 'Billing', value: 'Billing' },
        { label: 'Renewal', value: 'Renewals' },
        { label: 'Other', value: 'Support' },
    ],
    'Registered Agent': [
        { label: 'Request physical mail forwarding', value: 'RA Support' },
        { label: 'Mail tracking', value: 'RA Support' },
        { label: 'Billing', value: 'Billing' },
        { label: 'Amazon questions', value: 'RA Support' },
        { label: 'Cancelation', value: 'Billing' },
        { label: 'Other', value: 'RA Support' },
    ],
    'Pro Registered Agent': [
        { label: 'Request physical mail forwarding', value: 'RA Support' },
        { label: 'Mail tracking', value: 'RA Support' },
        { label: 'Billing', value: 'Billing' },
        { label: 'Amazon questions', value: 'RA Support' },
        { label: 'Cancelation', value: 'Billing' },
        { label: 'Other', value: 'RA Support' },
    ],
    'Tax Preparation (Personal)': [],
    'Estate Planning (PRIME)': [
        { label: 'Plan questions', value: 'Support' },
        { label: 'Technical support', value: 'Support' },
        { label: 'Cancelation', value: 'Billing' },
        { label: 'Other', value: 'Support' },
    ],
    'Estate Planning (Unlimited)': [
        { label: 'Plan questions', value: 'Support' },
        { label: 'Technical support', value: 'Support' },
        { label: 'Cancelation', value: 'Billing' },
        { label: 'Other', value: 'Support' },
    ],
    'Branded Domain & Email': [
        { label: 'Technical issues', value: 'Support' },
        { label: 'Billing', value: 'Support' },
        { label: 'Ownership questions', value: 'Support' },
        { label: 'Cancelation', value: 'Billing' },
        { label: 'Other', value: 'Support' },
    ],
    'Bankable Website': [
        { label: 'Updates and edits', value: 'Support' },
        { label: 'Billing', value: 'Billing' },
        { label: 'Cancelation', value: 'Billing' },
        { label: 'Other', value: 'Support' },
    ],
};
